import Swiper, { Navigation } from "swiper";
import { updateProgressbar } from "../utils";

(function () {
  const primaryCtaWidgets = document.querySelectorAll(".js-promo");

  primaryCtaWidgets.forEach(function (widget) {
    const carousel = widget.querySelector(".js-promoCarousel");
    const controls = widget.querySelector(".js-carouselControls");

    const progressbarEl = controls.querySelector(".js-carouselProgressBar");

    const nextBtn = controls.querySelector(".js-carouselNext");
    const prevBtn = controls.querySelector(".js-carouselPrev");

    const swiper = new Swiper(carousel, {
      modules: [Navigation],
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 0,
      on: {
        init: (s) => {
              updateProgressbar(progressbarEl, s);
              // console.log(s);
              if (s.slides.length <= 1) {
                  controls.style.display = "none";
              }
        },
        slideChange: (s) => {
          updateProgressbar(progressbarEl, s);
        },
      },
    });
  });
})();
